module.exports = __webpack_public_path__ + "media/correctAnswer.7b2e37bb.mp3";